import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const POPULAR_GAMES = [
  { icon: '🟩', title: 'Wordle',    path: '/wordle'    },
  { icon: '🎭', title: 'Hangman',   path: '/hangman'   },
  { icon: '🔗', title: 'Connections', path: '/connections' },
  { icon: '🔀', title: 'Jumble Solver', path: '/jumble' },
  { icon: '🃏', title: 'Scrabble Finder', path: '/scrabble' },
  { icon: '🎲', title: 'Random Word Generator', path: '/random-word-generator' },
];

const TILE_STATES = ['correct', 'present', 'absent'];

function AnimatedTile({ letter, delay }) {
  const [state, setState] = useState('absent');

  useEffect(() => {
    const t = setTimeout(() => {
      setState(TILE_STATES[Math.floor(Math.random() * TILE_STATES.length)]);
    }, delay);
    return () => clearTimeout(t);
  }, [delay]);

  const colors = {
    correct: { bg: '#538d4e', border: '#538d4e', color: '#fff' },
    present: { bg: '#b59f3b', border: '#b59f3b', color: '#fff' },
    absent:  { bg: '#3a3a3c', border: '#3a3a3c', color: '#fff' },
  };
  const c = colors[state];

  return (
    <div style={{
      width: 56, height: 56, display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: 'Nunito, sans-serif', fontWeight: 900, fontSize: '1.6rem', color: c.color,
      background: c.bg, border: `3px solid ${c.border}`, borderRadius: 6,
      transition: 'background 0.4s, border-color 0.4s',
      userSelect: 'none',
    }}>
      {letter}
    </div>
  );
}

export default function NotFound() {
  const location = useLocation();

  return (
    <div style={{ minHeight: '80vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '2rem 1rem', textAlign: 'center' }}>

      {/* Wordle-style "404" tiles */}
      <div style={{ display: 'flex', gap: 8, marginBottom: '1.5rem' }}>
        {['4', '0', '4'].map((letter, i) => (
          <AnimatedTile key={i} letter={letter} delay={300 + i * 200} />
        ))}
      </div>

      <h1 style={{ fontFamily: 'Nunito, sans-serif', fontWeight: 900, fontSize: 'clamp(1.6rem, 5vw, 2.4rem)', color: '#1e293b', marginBottom: '0.5rem' }}>
        Page Not Found
      </h1>

      <p style={{ fontSize: '1.05rem', color: '#64748b', maxWidth: 420, lineHeight: 1.7, marginBottom: '0.75rem' }}>
        Hmm — <strong style={{ color: '#4f46e5' }}>{location.pathname}</strong> doesn't exist
        in our dictionary. It may have been moved, deleted, or you may have mistyped the URL.
      </p>

      <p style={{ fontSize: '0.9rem', color: '#94a3b8', marginBottom: '2rem' }}>
        Like in Wordle — not every guess is a word. Let's get you back on track!
      </p>

      <Link to="/" className="btn fw-bold mb-4"
        style={{ borderRadius: 50, background: 'var(--primary)', color: '#fff', border: 'none', fontFamily: 'Nunito, sans-serif', padding: '0.7rem 2rem', fontSize: '1rem' }}>
        🏠 Back to Home
      </Link>

      {/* Popular games suggestions */}
      <div style={{ width: '100%', maxWidth: 560 }}>
        <p className="fw-bold mb-3" style={{ color: '#374151', fontSize: '0.9rem' }}>
          Or jump straight into a game:
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))', gap: 10 }}>
          {POPULAR_GAMES.map(({ icon, title, path }) => (
            <Link key={path} to={path}
              style={{
                display: 'flex', alignItems: 'center', gap: 8,
                background: '#fff', border: '2px solid var(--border)', borderRadius: 12,
                padding: '0.6rem 0.85rem', textDecoration: 'none',
                fontFamily: 'Nunito, sans-serif', fontWeight: 700, fontSize: '0.82rem', color: '#374151',
                transition: 'border-color 0.15s, color 0.15s',
              }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--primary)'; e.currentTarget.style.color = 'var(--primary)'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.color = '#374151'; }}>
              <span style={{ fontSize: '1.1rem' }}>{icon}</span>
              {title}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
